import * as yup from 'yup';
import { Testimonial } from '@web/components';
import { requiredImageFromCMSSchema, richTextFromCMSSchema } from '../schemas';

export const component = Testimonial;

export const schema = yup
  .object({
    photo: requiredImageFromCMSSchema,
    description: yup.string().required(),
    rating: yup.number().required(),
    body: richTextFromCMSSchema.required(),
    name: yup.string().required(),
  })
  .transform(value => ({
    photo: value.photo,
    description: `${value.pup_age} ${value.breed}`,
    body: value.body,
    name: value.name,
    rating: 5,
  }));
